import { react, useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import Stack from '@mui/material/Stack';
import AlertDialog from '../Modals/AlertDialog'
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import StoreIcon from '@mui/icons-material/Store';
import SignpostIcon from '@mui/icons-material/Signpost';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import Paper from '@mui/material/Paper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function StoreSelection(props) {
    const retailsStores = [
        {
            value: 'Meijer',
            label: '',
            img: '/images/Grocery/Meijer.svg'
        },
        {
            value: 'Target',
            label: '',
            img: '/images/Grocery/Target.png'
        },
        {
            value: 'Walmart',
            label: '',
            img: '/images/Grocery/Walmart.png'
        },
        {
            value: 'Family Dollar',
            label: '',
            img: '/images/Grocery/FamilyDollar.png'
        },
        {
            value: 'Gordon Foods',
            label: '',
            img: '/images/Grocery/GordonFoods.png'
        },
        {
            value: 'IGA',
            label: '',
            img: '/images/Grocery/IGA.png'
        },
        {
            value: 'Dollar Green',
            label: '',
            img: '/images/Grocery/DollarTree.png'
        },
        {
            value: 'Sams Club',
            label: '',
            img: '/images/Grocery/SamsClub.png'
        },
        {
            value: 'Costco',
            label: '',
            img: '/images/Grocery/Costco.png'
        },
    ];

    const [selectedStores, setSelectedStores] = useState(props.pickupRequest.SelectedStores !== undefined ? props.pickupRequest.SelectedStores : []);
    const [otherStore, setOtherStore] = useState(props.pickupRequest.OtherStore);

    function toggleSelected(val) {
        if (val !== null) {
            let selectedStoresCopy;
            if (selectedStores.includes(val)) {
                // remove it
                selectedStoresCopy = [];
                for (let i = 0; i < selectedStores.length; i++) {
                    if (selectedStores[i] !== val) {
                        selectedStoresCopy.push(selectedStores[i]);
                    }
                }
            }
            else {
                selectedStoresCopy = selectedStores.splice(0);
                selectedStoresCopy.push(val);
            }

            setSelectedStores(selectedStoresCopy);
        }
    }
    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            {props.onUpdated !== undefined ? null :
                <>
                    <div className={styles.cardHeader}>Store Selection</div>

                    <div className={styles.cardQuestion} style={{ marginTop: '15px' }}>
                        Are you able to identify the which store(s) your Recycler should return to?
                        <div style={{ fontSize: '14pt', fontStyle: 'italic' }}>(optional)</div>
                    </div>

                    <div style={{ marginTop: '15px', display: 'flex' }}>
                        <DirectionsCarIcon sx={{ color: 'var(--sipzee-grey)', fontSize: 50 }} />
                        <div>Your Recycler will be returning your cans & bottles to a retail store just like you would. Helping them to identify where to begin can save them time and gas.</div>
                    </div>
                </>
            }
            <div style={{ marginTop: '15px', display: 'flex', flexWrap: 'wrap' }}>
                {retailsStores.map((retailStore, index) => (

                    <div key={retailStore.value} style={{position:'relative', display: 'flex', flexDirection: 'row', margin:'2px' }} onClick={(e) => toggleSelected(retailStore.value) }>
                        {/* {<StyledCheckbox style={{ alignSelf: 'center' }} />}*/}
                        <Paper elevation={8} className={styles.paperImageCard} style={{ height: '75px', width: '75px', display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', alignSelf: 'center' }}>
                                <img src={retailStore.img} style={{ maxHeight: '60px', maxWidth: '60px' }} />
                                <div style={{ alignSelf: 'center' }}>{retailStore.label}</div>
                                {!selectedStores.includes(retailStore.value) ? null :
                                    <CheckCircleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30 }} style={{ position: 'absolute', backgroundColor:'none', top:'0px', left:'-5px' }}/>
                                   }
                            </div>
                        </Paper>
                    </div>
                ))}
               
            </div>

            <div style={{ marginTop: '15px' }}>
                <TextField label="Other Store"
                    
                    onChange={(e) => setOtherStore(e.target.value)}
                    value={otherStore}
                    variant="outlined"
                />
            </div>
            {props.onUpdated !== undefined ?
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                        <Button onClick={props.onBack} style={{ marginRight: '2px' }}>Cancel</Button>
                        <Button onClick={() => props.onUpdated(selectedStores, otherStore)}>Save</Button>
                    </div>
                </div>
                :
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                    <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                        <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                        <Button variant="contained" color="sipzeeGreen" onClick={() => props.onNext(selectedStores, otherStore)}>Next <KeyboardArrowRight /></Button>
                    </div>
                </div>
            }
        </div>
    )

}